
(() => {
  if (window.BNPdpResidualLoaded) return;
  window.BNPdpResidualLoaded = true;

  const safeParse = (raw) => {
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  };

  class BNPdpViewCounter {
    constructor(element) {
      this.element = element;
      this.output = element.querySelector('[data-count]');
      this.initialValue = Number.parseInt(element.dataset.initialNumber, 10) || 0;
      this.storageKey = element.dataset.storageKey || '';
      this.bumpMin = Number.parseInt(element.dataset.bumpMin, 10) || 140;
      this.bumpMax = Number.parseInt(element.dataset.bumpMax, 10) || 260;
      this.refreshWindow = (Number.parseInt(element.dataset.refreshMinutes, 10) || 5) * 60 * 1000;
      this.tick = this.tick.bind(this);
      this.start();
    }

    randomBetween(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    readState(now) {
      if (!this.storageKey) {
        return { value: this.initialValue, updatedAt: now };
      }

      const parsed = safeParse(localStorage.getItem(this.storageKey));
      if (!parsed || typeof parsed.value !== 'number' || typeof parsed.updatedAt !== 'number') {
        return { value: this.initialValue, updatedAt: now };
      }

      return parsed;
    }

    writeState(state) {
      if (!this.storageKey) return;
      localStorage.setItem(this.storageKey, JSON.stringify(state));
    }

    tick(force = false) {
      const now = Date.now();
      const state = this.readState(now);
      const elapsed = now - state.updatedAt;

      if (force || elapsed >= this.refreshWindow) {
        state.value += this.randomBetween(this.bumpMin, this.bumpMax);
        state.updatedAt = now;
        this.writeState(state);
      }

      if (this.output) {
        this.output.textContent = new Intl.NumberFormat('es-CL').format(state.value);
      }
    }

    start() {
      this.tick(true);
      window.setInterval(this.tick, 60 * 1000);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.tick();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-bn-pdp-view-counter]').forEach((element) => {
      new BNPdpViewCounter(element);
    });

    document.querySelectorAll('[data-bn-demo-download]').forEach((button) => {
      button.addEventListener('click', () => {
        const url = button.dataset.pdfUrl;
        if (url) {
          window.open(url, '_blank', 'noopener');
        }
      });
    });
  });
})();

